var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardApplePay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    style: {
      enableBackground: "new 0 0 120 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "export-badges"
  }, /*#__PURE__*/React.createElement("g", {
    id: "production-final",
    transform: "translate(-36.000000, -6018.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card_google_pay",
    transform: "translate(36.000000, 6018.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-11",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: "M4,0h112c2.2,0,4,1.8,4,4v72c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M726.4-56417.9c-21.4-5.5-41.9-28.7-45.5-51.8c-1.7-10.4-1.7-10.4,6-10.4c23.4,0,50.1,31.1,47.7,55.6 C733.9-56416.2,733.7-56416,726.4-56417.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.7-56440.3c-1.9-0.5-10.8-1.7-19.8-2.4l-16.4-1.7v-126.2v-126.2h10.8h10.8v52.8v52.8l28.4,1 c24.1,0.7,30.1,1.7,41.4,7c18.5,8.7,29.9,19.3,37.8,35.4c5.5,11.8,6.5,16.9,6.7,35.4c0,17.8-1,23.6-5.5,33 c-7.5,14.9-23.6,28.9-39.3,34C947.1-56441.7,911.5-56438.4,903.7-56440.3z M956-56467.5c19-9.9,29.1-31.3,26-54.4 c-4.3-33-26.5-49.6-66.2-49.6c-10.4,0-20.5,0.7-22.6,1.4c-3.4,1.2-3.9,8.4-3.9,53.7c0,28.9,0.7,53.2,1.9,54.2 c1,1,13.7,1.4,28.2,1C940.8-56462,947.8-56463.2,956-56467.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.1-56487c-48.7-12-67.5-74-42.6-140.9c7.5-20.2,25.3-47.9,38.5-59.7c12-10.8,23.1-12,43.4-4.3c16.1,6,34.7,6,48.4,0 c13.2-6,28.2-6,38.1-0.2c9.9,6.3,24.8,26,35.4,47.7c8.9,17.8,10.1,22.4,6.7,22.4c-1.2,0-6.7,4.1-12.5,8.9 c-28.7,24.6-28.9,70.1-0.5,94.9l8.7,7.7l-10.1,9.2c-19,16.6-44.3,21-69.9,11.6c-21-7.9-25.1-7.9-44.6-1.2 C643.6-56484.9,636.1-56483.9,623.1-56487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.1-56512.3c-11.6-3.1-25.5-9.9-27.2-13c-1.7-2.4,5.1-18.1,7.2-16.9c27.2,14,48.4,16.4,63.6,7.7 c10.1-5.8,19-22.6,19-35.9v-9.9l-23.6-2.6c-13-1.7-29.9-5.3-37.6-8.2c-40-15.4-55.2-61.7-29.6-90.6 c10.4-11.8,23.8-17.6,41.4-17.6c15.4,0,33.7,7,43.8,16.6c2.9,2.7,6,5.1,6.5,5.1c0.7,0,2.2-4.3,2.9-9.9c1.7-9.6,1.7-9.6,11.6-8.9 c7.2,0.5,9.6,1.7,8.9,4.3c-0.2,1.9-1.4,34.4-2.4,72.3c-1.4,65.3-1.7,69.1-7.2,80.2C1117.9-56514,1086.8-56502.9,1053.1-56512.3z  M1115.7-56623.4c0-25.1-2.2-31.8-13.7-42.6c-20.2-19.3-52.3-17.8-62.6,2.9c-4.8,9.6-3.9,28.4,1.9,37.8 c8.7,14,34.2,23.6,64.3,24.6l10.1,0.2V-56623.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.3-56516.2c0.7-1.2,16.1-40.7,34-87.2l32.3-84.8l-7-14.7c-9.6-20.5-24.3-38.1-39.7-47.5 c-7.5-4.3-13.5-9.2-13.5-10.8c0-5.1,5.5-15.2,8.2-15.2c5.3,0,27,14.2,35.7,23.4c12,12.3,28.9,42.4,40.2,71.8 c5.3,13.2,19.8,50.6,32.3,83.1c12.5,32.5,25.1,64.8,27.9,71.8l5.1,12.5h-11.8h-11.8l-7-18.6c-4.1-10.4-15.7-42.9-26.3-72.3 c-17.6-49.9-22.4-60.2-22.6-49.4c-0.2,2.2-11.8,34.4-26,71.5l-26,67.5l-12.8,0.7C1162.7-56513.8,1159.1-56514.3,1160.3-56516.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardApplePay);
export default __webpack_public_path__ + "static/media/card_apple-pay.7b478b0f57a6e000c4f796a0baa44e06.svg";
export { ForwardRef as ReactComponent };